import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { zefDialogClose, onZefDialogOpen } from '@zerops/zef/dialog';
import { UserDataAddForm } from '@zerops/zui/user-data-add-form';
import { ZefSnackService } from '@zerops/zef/snack';
import { map, filter, switchMap, delay } from 'rxjs/operators';
import { FEATURE_NAME } from './project-env-add-dialog.constant';
import { addProjectCustomEnvSuccess } from '@zerops/zerops/core/project-base/project-base.action';

@Injectable()
export class ProjectEnvAddDialogEffect {

  onDialogOpenFocusInput$ = createEffect(() => this._actions$.pipe(
    onZefDialogOpen(FEATURE_NAME),
    delay(100),
    map(() => this._userDataAddForm.focus('key'))
  ));

  // the secret/custom distinction is driven by which section's "Add" button opened
  // the dialog - the section passes `sensitive` through the dialog meta
  onDialogOpenSetSensitive$ = createEffect(() => this._actions$.pipe(
    onZefDialogOpen(FEATURE_NAME),
    map(({ meta }) => this._userDataAddForm.setValue(
      'sensitive',
      !!(meta as { sensitive?: boolean; })?.sensitive
    ))
  ));

  #onAddSuccess$ = this._actions$.pipe(
    ofType(addProjectCustomEnvSuccess)
  );

  onAddSuccessDialogClose$ = createEffect(() => this.#onAddSuccess$.pipe(
    map(() => zefDialogClose({ key: FEATURE_NAME }))
  ));

  onDialogCloseResetForm$ = createEffect(() => this._actions$.pipe(
    ofType(zefDialogClose),
    filter((action) => action?.key === FEATURE_NAME),
    delay(500),
    switchMap(() => [
      this._userDataAddForm.reset(),
      this._userDataAddForm.setDefaultValues()
    ])
  ));

  onAddSuccessNotification$ = createEffect(() => this.#onAddSuccess$.pipe(
    filter(({ originalAction }) => originalAction?.meta?.source === FEATURE_NAME),
    switchMap(() => this._snack.success$({ translation: `${FEATURE_NAME}.addSuccess` }))
  ), { dispatch: false });

  constructor(
    private _actions$: Actions,
    private _userDataAddForm: UserDataAddForm,
    private _snack: ZefSnackService
  ) {}
}
